var _path, _circle, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00842 62.4942C17.8919 44.6253 38.8432 33 62.5 33C86.1568 33 107.108 44.6253 119.992 62.4942H120L119.996 62.5L120 62.5058H119.992C107.108 80.3747 86.1568 92 62.5 92C38.8432 92 17.8919 80.3747 5.00842 62.5058H5L5.00421 62.5L5 62.4942H5.00842Z",
    fill: "url(#paint0_radial_3124_25414)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 14.5,
    fill: "url(#paint1_radial_3124_25414)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3588 85.824C54.9115 86.311 46.5064 82.1258 41.9872 74.2984C35.6029 63.2404 39.3917 49.1006 50.4497 42.7162C61.5077 36.3318 75.6476 40.1206 82.0319 51.1786C87.6035 60.829 85.4273 72.8264 77.4332 79.9679",
    stroke: "url(#paint2_linear_3124_25414)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 16C38 17.6569 36.6569 19 35 19C33.3431 19 32 17.6569 32 16C32 14.3431 33.3431 13 35 13C36.6569 13 38 14.3431 38 16ZM35.8109 20.9346C35.547 20.9776 35.2761 21 35 21C32.2386 21 30 18.7614 30 16C30 13.2386 32.2386 11 35 11C37.7614 11 40 13.2386 40 16C40 17.4017 39.4232 18.6686 38.4941 19.5765L56.7881 50.2313L54.2119 51.7687L35.8109 20.9346Z",
    fill: "url(#paint3_radial_3124_25414)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119 62C119 63.6569 117.657 65 116 65C114.343 65 113 63.6569 113 62C113 60.3431 114.343 59 116 59C117.657 59 119 60.3431 119 62ZM121 62C121 64.7614 118.761 67 116 67C113.761 67 111.866 65.5286 111.229 63.5H74.5V60.5H111.229C111.866 58.4714 113.761 57 116 57C118.761 57 121 59.2386 121 62Z",
    fill: "url(#paint4_radial_3124_25414)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6618 105.595C39.4921 106.488 40 107.685 40 109C40 111.761 37.7614 114 35 114C32.2386 114 30 111.761 30 109C30 106.239 32.2386 104 35 104C35.3617 104 35.7145 104.038 36.0544 104.111L53.6878 72.2732L56.3122 73.7267L38.6618 105.595ZM38 109C38 110.657 36.6569 112 35 112C33.3431 112 32 110.657 32 109C32 107.343 33.3431 106 35 106C36.6569 106 38 107.343 38 109Z",
    fill: "url(#paint5_radial_3124_25414)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3124_25414",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.2568 50.9878) rotate(152.64) scale(89.2392 66.1489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3124_25414",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.9865 56.8415) rotate(134.754) scale(28.3871 25.7753)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3124_25414",
    x1: 40.2535,
    y1: 56.475,
    x2: 80.8442,
    y2: 73.4269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3124_25414",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.462 23.4295) rotate(123.083) scale(33.8224 28.0926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3124_25414",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.547 60.0488) rotate(167.762) scale(32.7925 12.3369)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3124_25414",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1341 84.9948) rotate(122.014) scale(34.2074 27.9241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonitoring);
export default __webpack_public_path__ + "static/media/ic_monitoring.458d54e498117b93e2d1dbd6f2bd3b36.svg";
export { ForwardRef as ReactComponent };